// src/components/common/Modal.jsx - Updated with better height handling
import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children }) => {
  // Close modal when Escape key is pressed
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      // Prevent scrolling on body when modal is open
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity overflow-y-auto">
      <div 
        className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-auto transform transition-transform"
        onClick={(e) => e.stopPropagation()}
        style={{ maxHeight: '90vh' }} // Set max height relative to viewport height
      >
        {/* Header - Fixed at top */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl z-10">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        {/* Content - Scrollable area */}
        <div className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 85px)' }}> {/* Subtract header height */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;